import { render, staticRenderFns } from "./sourdialog.vue?vue&type=template&id=9e5f64be&scoped=true"
import script from "./sourdialog.vue?vue&type=script&lang=js"
export * from "./sourdialog.vue?vue&type=script&lang=js"
import style0 from "./sourdialog.vue?vue&type=style&index=0&id=9e5f64be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5f64be",
  null
  
)

export default component.exports